import { useState, useEffect } from 'react';
import cn from 'classnames';
import PanelGroup, { Panel } from '@dealroadshow/uikit/core/components/PanelGroup';
import IconArrowDown from '@dealroadshow/uikit/core/components/Icon/IconArrowDown';
import IconQuestionOutlined from '@dealroadshow/uikit/core/components/Icon/IconQuestionOutlined';
import SectionHeader from '@/Framework/UI/Pages/Landing/Sections/SectionHeader';
import styles from './faq.scss';

interface IProps {
  collection: {
    hash?: string,
    question: string,
    answer: React.ReactNode,
  }[],
  activePanel?: string,
  wrapperClassName?: string,
}

const Faq = ({
  collection,
  activePanel,
  wrapperClassName,
}: IProps) => {
  const [activePanelHash, setActivePanelHash] = useState(null);

  useEffect(() => {
    // Hydration doesn't work correctly with simple classname variable
    // in case when isActive is depends on browser url hash
    setTimeout(() => {
      setActivePanelHash(activePanel);
    }, 0);
  }, [activePanel]);

  const panels = collection.map((item) => (
    <Panel
      key={ item.hash }
      id={ item.hash }
      header={ (
        <>
          <IconQuestionOutlined className={ styles.questionIcon } />
          { item.question }
        </>
      ) }
      className={ styles.panel }
      activeClass={ styles.activePanel }
      headerClass={ styles.panelHeader }
      arrowWrapperClass={ styles.arrowWrapper }
      arrow={ (
        <div className={ styles.panelIcon }>
          <IconArrowDown />
        </div>
      ) }
      renderDefaultArrow
    >
      <div className={ styles.panelContent }>
        { item.answer }
      </div>
    </Panel>
  ));

  return (
    <div className={ cn(styles.faqWrp, wrapperClassName) }>
      <SectionHeader
        title="Frequently Asked Questions."
        className={ styles.header }
      />
      <PanelGroup
        dataTest="faqPanelGroup"
        defaultActiveKey={ activePanelHash }
        className={ styles.panelGroup }
      >
        { panels }
      </PanelGroup>
    </div>
  );
};

export default Faq;
